export default "__VITE_ASSET__BftldoyF__ 320w, __VITE_ASSET__Dnm2HKZi__ 480w, __VITE_ASSET__Dqz4wbEN__ 640w, __VITE_ASSET__a7Awb48o__ 800w";